import { OrderShippingLabelArgs } from 'types/api/arguments/order-shipping-label-args'
import { OrderShippingLabelResp } from 'types/api/response/order-shipping-label-resp'

import { api } from './api'

export const orderShippingLabel = ({
  sellerAddressId,
  transactionId,
  pickUpDate,
  digitalLabelType,
  dropOffTypeKey,
  selectedDropOffPointType,
}: OrderShippingLabelArgs) =>
  api.put<OrderShippingLabelResp>(`transactions/${transactionId}/shipment/order`, {
    seller_address_id: sellerAddressId,
    pick_up_date: pickUpDate,
    digital_label_type: digitalLabelType,
    drop_off_type_key: dropOffTypeKey,
    drop_off_type: selectedDropOffPointType,
  })
